module.exports = __webpack_public_path__ + "img/oro.06afa462.png";